import { axiosInstance } from "./api";
import { PolicyLine } from "../redux/reducers/types/actuaryTypes";

export const getAvailablePolicyLines = () => {
    return axiosInstance.get(`/api/v1/policy-lines/`);
};

export const searchSimilarPolicyLines = (query: string, threshold: number = 0.7) => {
    return axiosInstance.get(`/api/v1/policy-lines/search_similar/`, {
        params: { q: query, threshold },
    });
};

export const createPolicyLine = (data: { name: string; description?: string; search_tags?: string }) => {
    return axiosInstance.post(`/api/v1/policy-lines/`, data);
};

export const public_submitActuaryGuess = (data: any) => {
    return axiosInstance.post(`/api/v1/guess/`, data);
};

export const getActuarialStatsForPolicyLine = (policyLineId: number) => {
    return axiosInstance.get(`/api/v1/policy-lines/${policyLineId}/`);
};
